import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiMethod } from 'src/app/decorators/api-method.decorator';
import { PreferredUserAccessInfo } from 'src/app/models/auth/preferred-user-access-info.model';
import { Deficiency } from 'src/app/models/deficiencies/deficiency.model';
import { UserAccountInfo } from 'src/app/models/user-account-info.model';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../auth.service';
import { AccountRouteService } from '../../interfaces/account-route-service.abstract';

@Injectable({
	providedIn: 'root'
})
export class DeficienciesService extends AccountRouteService {

	private baseDeficienciesUrl = `${environment.baseUrl}/deficiencies`;

	constructor(
		private httpClient: HttpClient,
		private authService: AuthService
	) {
		super();
	}

	@ApiMethod()
	getDeficiency(token: string): Observable<Deficiency> {
		return this.httpClient.get<Deficiency>(`${this.baseDeficienciesUrl}/${token}`);
	}

	@ApiMethod()
	getDeficienciesList(token: string, numberOfDays?: number, jobId?: number): Observable<Deficiency> {
		return this.httpClient.get<Deficiency>(`${this.baseDeficienciesUrl}/${token}`,
			{
				params:
				{
					numberOfDays: numberOfDays?.toString() || '',
					jobId: jobId?.toString() || ''
				}
			});
	}

	@ApiMethod()
	isUserAccountAllowedAccess(token: string): Observable<PreferredUserAccessInfo> {
		return this.httpClient.get<PreferredUserAccessInfo>(`${this.baseDeficienciesUrl}/${token}/is-authorized`, { headers: this.authService.getAuthenticationHeader() });
	}

	@ApiMethod()
	getRedirectUri(token: string): Observable<{ smartSyncUri: string }> {
		return this.httpClient.get<{ smartSyncUri: string }>(`${this.baseDeficienciesUrl}/${token}/url`);
	}

	@ApiMethod()
	getDeficienciesRedirectUriById(userAccountId: number): Observable<{ smartSyncUri: string }> {
		return this.httpClient.get<{ smartSyncUri: string }>(`${this.baseDeficienciesUrl}/${userAccountId}/id-url`, { headers: this.authService.getAuthenticationHeader() });
	}

	@ApiMethod()
	getUserAccountInfo(token: string): Observable<UserAccountInfo> {
		return this.httpClient.get<UserAccountInfo>(`${this.baseDeficienciesUrl}/${token}/user-info`);
	}
}

